import { render } from "./SpecifiedCommercialTransactions.vue?vue&type=template&id=5f8f0e5d&scoped=true"
import script from "./SpecifiedCommercialTransactions.vue?vue&type=script&lang=js"
export * from "./SpecifiedCommercialTransactions.vue?vue&type=script&lang=js"

import "./SpecifiedCommercialTransactions.vue?vue&type=style&index=0&id=5f8f0e5d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f8f0e5d"]])

export default __exports__